// extracted by mini-css-extract-plugin
export var root = "PrismTheme-module--root--dw7q0";